import '../../App.css';
import Seo from '../../components/common/atoms/Seo';
import seoData from '../../json/seo.json';
import textData from '../../json/text.json';
import Header from '../../components/menu/organisms/Header';
import Footer from  '../../components/footer/Footer';
import TopicPath from '../../components/common/atoms/TopicPath';
import H1 from '../../components/common/atoms/H1';
import BackgroundAnimation from '../../components/motion/atoms/BackgroundAnimation';
import SesContent from '../../components/service/organisms/SesContent';

/**
 * システムエンジニアリングサービスページ
 * @returns 
 */
function Ses() {
  const links = [{link:'/ses', pageName:textData['menu.service.development']['ja']}];
  const titleText = textData['menu.service.development']['ja'];
  return (

    <div>
      <BackgroundAnimation />
      <Seo title={titleText} description={seoData.pages.ses.description} path='/ses' />

      <header>
        <Header />
      </header>
      
      <main className="main-content">
        <TopicPath links={links} />
        <H1 text={titleText}/>
        <SesContent />
      </main>
      <footer>
        <Footer />
      </footer>

    </div>
  );
}

export default Ses;
